// extracted by mini-css-extract-plugin
module.exports = {"owduyfw":"owduyfw","c1va82ni":"c1va82ni","sisyji7":"sisyji7","so1es9b":"so1es9b","s17tlxie":"s17tlxie"};